<div [formGroup]="familyMemberAddressForm">
  <div class="row">
    <div class="col">
      <mat-checkbox formControlName="isStayingInTheSameHousehold">{{ 'IsStayingInTheSameHousehold' | translate }}</mat-checkbox>
    </div>
  </div>

  @if (familyMemberAddressForm?.get('isStayingInTheSameHousehold')?.value === false) {
    <div
      >
      @switch (familyMemberAddressForm?.get('country')?.value) {
        <!-- Polish -->
        @case (Country.Poland) {
          <div>
            <div class="row">
              <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Country' | translate }}</mat-label>
                  <mat-select formControlName="country">
                    @for (country of listOfCountries$ | async; track country) {
                      <mat-option [value]="country.Id"> {{ country.Name }} </mat-option>
                    }
                  </mat-select>
                  @if (familyMemberAddressForm?.get('country')?.invalid && familyMemberAddressForm?.get('country')?.touched) {
                    <mat-error>
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div formGroupName="polishAddress" class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'District' | translate }}</mat-label>
                  <mat-select id="district" (selectionChange)="onSelectionChange($event)" formControlName="district">
                    @for (district of listOfDistricts$ | async; track district) {
                      <mat-option [value]="district.Id"> {{ district.Name }}</mat-option>
                    }
                  </mat-select>
                  @if (
                    familyMemberAddressForm?.get('polishAddress.district')?.invalid && familyMemberAddressForm?.get('polishAddress.district')?.touched
                    ) {
                    <mat-error
                      >
                      {{ 'InvalidField' | translate }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
            <div formGroupName="polishAddress" class="row">
              <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Poviat' | translate }}</mat-label>
                  <input
                    matInput
                    id="poviat"
                    formControlName="poviat"
                    type="text"
                    placeholder="{{ 'Poviat' | translate }}"
                    [matAutocomplete]="autocompletePoviat"
                    (change)="onResetNextFormControls($event)"
                    required
                    />
                    <mat-autocomplete #autocompletePoviat="matAutocomplete" [displayWith]="displayValue">
                      @for (poviat of listOfPoviats$ | async; track poviat) {
                        <mat-option [value]="poviat" (onSelectionChange)="setSelectedPoviat(poviat)">
                          {{ poviat.Name }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                    @if (familyMemberAddressForm?.get('polishAddress.poviat')?.invalid && familyMemberAddressForm?.get('polishAddress.poviat')?.touched) {
                      <mat-error
                        >
                        {{ 'InvalidField' | translate }}
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div class="col-12 col-lg-6">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'Commune' | translate }}</mat-label>
                    <input
                      matInput
                      id="commune"
                      formControlName="commune"
                      type="text"
                      placeholder="{{ 'Commune' | translate }}"
                      [matAutocomplete]="autocompleteCommune"
                      (change)="onResetNextFormControls($event)"
                      required
                      />
                      <mat-autocomplete #autocompleteCommune="matAutocomplete" [displayWith]="displayValue">
                        @for (commune of listOfCommune$ | async; track commune) {
                          <mat-option [value]="commune" (onSelectionChange)="setSelectedCommune(commune)">
                            {{ commune.Name }}
                          </mat-option>
                        }
                      </mat-autocomplete>
                      @if (familyMemberAddressForm?.get('polishAddress.commune')?.invalid && familyMemberAddressForm?.get('polishAddress.commune')?.touched) {
                        <mat-error
                          >
                          {{ 'InvalidField' | translate }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
                <div formGroupName="polishAddress" class="row">
                  <div class="col-12 col-lg-4">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'City' | translate }}</mat-label>
                      <input
                        matInput
                        id="city"
                        formControlName="city"
                        type="text"
                        placeholder="{{ 'City' | translate }}"
                        [matAutocomplete]="autocompleteCity"
                        (change)="onResetNextFormControls($event)"
                        required
                        />
                        <mat-autocomplete #autocompleteCity="matAutocomplete" [displayWith]="displayValue">
                          @for (city of listOfCities$ | async; track city) {
                            <mat-option [value]="city" (onSelectionChange)="setSelectedCity(city)">
                              {{ city.Name }}
                            </mat-option>
                          }
                        </mat-autocomplete>
                        @if (familyMemberAddressForm?.get('polishAddress.city')?.invalid && familyMemberAddressForm?.get('polishAddress.city')?.touched) {
                          <mat-error
                            >
                            {{ 'InvalidField' | translate }}
                          </mat-error>
                        }
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-4">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Street' | translate }}</mat-label>
                        <input
                          matInput
                          id="street"
                          formControlName="street"
                          type="text"
                          placeholder="{{ 'Street' | translate }}"
                          [matAutocomplete]="autocompleteStreet"
                          required
                          />
                          <mat-autocomplete #autocompleteStreet="matAutocomplete" [displayWith]="displayValue">
                            @for (street of listOfStreets$ | async; track street) {
                              <mat-option [value]="street" (onSelectionChange)="setSelectedStreet(street)">
                                {{ street.Name }}
                              </mat-option>
                            }
                          </mat-autocomplete>
                          @if (familyMemberAddressForm?.get('polishAddress.street')?.invalid && familyMemberAddressForm?.get('polishAddress.street')?.touched) {
                            <mat-error
                              >
                              {{ 'InvalidField' | translate }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="col-6 col-lg-2">
                        <mat-form-field appearance="outline">
                          <mat-label>{{ 'HouseNumber' | translate }}</mat-label>
                          <input
                            matInput
                            formControlName="houseNumber"
                            type="text"
                            placeholder="{{ 'HouseNumber' | translate }}"
                            autocomplete="houseNumber"
                            required
                            />
                            @if (
                              familyMemberAddressForm?.get('polishAddress.houseNumber')?.invalid &&
                              familyMemberAddressForm?.get('polishAddress.houseNumber')?.touched
                              ) {
                              <mat-error
                                >
                                {{ 'InvalidField' | translate }}
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="col-6 col-lg-2">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'ApartmentNumber' | translate }}</mat-label>
                            <input
                              matInput
                              formControlName="apartmentNumber"
                              type="text"
                              autocomplete="apartmentNumber"
                              placeholder="{{ 'ApartmentNumber' | translate }}"
                              />
                              @if (
                                familyMemberAddressForm?.get('polishAddress.apartmentNumber')?.invalid &&
                                familyMemberAddressForm?.get('polishAddress.apartmentNumber')?.touched
                                ) {
                                <mat-error
                                  >
                                  {{ 'InvalidField' | translate }}
                                </mat-error>
                              }
                            </mat-form-field>
                          </div>
                        </div>
                        <div formGroupName="polishAddress" class="row">
                          <div class="col-12 col-lg-4">
                            <mat-form-field appearance="outline">
                              <mat-label>{{ 'Postcode' | translate }}</mat-label>
                              <input
                                matInput
                                formControlName="postcode"
                                autocomplete="postcode"
                                type="text"
                                placeholder="00-000"
                                minlength="6"
                                maxlength="6"
                                [matAutocomplete]="autocompletePostcode"
                                postCodeMask
                                required
                                />
                                <mat-autocomplete #autocompletePostcode="matAutocomplete" [displayWith]="displayPostcodeValue" (optionSelected)="setSelectedPostCode($event)">
                                  @for (option of listOfPostCodes$ | async; track option) {
                                    <mat-option [value]="option">
                                      {{ option.Name }} - {{ option.City.Name }} {{ option.City.Name !== option.City.Commune.Name ? '- ' + option.City.Commune.Name : '' }}
                                    </mat-option>
                                  }
                                </mat-autocomplete>
                                @if (
                                  familyMemberAddressForm?.get('polishAddress.postcode')?.invalid && familyMemberAddressForm?.get('polishAddress.postcode')?.touched
                                  ) {
                                  <mat-error
                                    >
                                    {{ 'InvalidField' | translate }}
                                  </mat-error>
                                }
                              </mat-form-field>
                            </div>
                            <div class="col-12 col-lg-8">
                              <mat-form-field appearance="outline">
                                <mat-label>{{ 'PostOffice' | translate }}</mat-label>
                                <input matInput formControlName="postOffice" type="text" autocomplete="postOffice" placeholder="{{ 'PostOffice' | translate }}" />
                                @if (
                                  familyMemberAddressForm?.get('polishAddress.postOffice')?.invalid && familyMemberAddressForm?.get('polishAddress.postOffice')?.touched
                                  ) {
                                  <mat-error
                                    >
                                    {{ 'InvalidField' | translate }}
                                  </mat-error>
                                }
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      }
                      <!-- Abroad -->
                      @default {
                        <div>
                          <div class="row">
                            <div class="col-12 col-lg-6">
                              <mat-form-field appearance="outline">
                                <mat-label>{{ 'Country' | translate }}</mat-label>
                                <mat-select formControlName="country">
                                  @for (country of listOfCountries$ | async; track country) {
                                    <mat-option [value]="country.Id"> {{ country.Name }} </mat-option>
                                  }
                                </mat-select>
                                @if (familyMemberAddressForm?.get('country')?.invalid && familyMemberAddressForm?.get('country')?.touched) {
                                  <mat-error>
                                    {{ 'InvalidField' | translate }}
                                  </mat-error>
                                }
                              </mat-form-field>
                            </div>
                            <div formGroupName="abroadAddress" class="col-12 col-lg-6">
                              <mat-form-field appearance="outline">
                                <mat-label>{{ 'District' | translate }}</mat-label>
                                <input
                                  type="text"
                                  placeholder="{{ 'District' | translate }}"
                                  formControlName="districtName"
                                  autocomplete="districtName"
                                  matInput
                                  required
                                  />
                                  @if (
                                    familyMemberAddressForm?.get('abroadAddress.districtName')?.invalid &&
                                    familyMemberAddressForm?.get('abroadAddress.districtName')?.touched
                                    ) {
                                    <mat-error
                                      >
                                      {{ 'InvalidField' | translate }}
                                    </mat-error>
                                  }
                                </mat-form-field>
                              </div>
                            </div>
                            <div formGroupName="abroadAddress" class="row">
                              <div class="col-12 col-lg-6">
                                <mat-form-field appearance="outline">
                                  <mat-label>{{ 'Poviat' | translate }}</mat-label>
                                  <input matInput type="text" placeholder="{{ 'Poviat' | translate }}" autocomplete="poviatName" formControlName="poviatName" />
                                  @if (
                                    familyMemberAddressForm?.get('abroadAddress.poviatName')?.invalid && familyMemberAddressForm?.get('abroadAddress.poviatName')?.touched
                                    ) {
                                    <mat-error
                                      >
                                      {{ 'InvalidField' | translate }}
                                    </mat-error>
                                  }
                                </mat-form-field>
                              </div>
                              <div class="col-12 col-lg-6">
                                <mat-form-field appearance="outline">
                                  <mat-label>{{ 'Commune' | translate }}</mat-label>
                                  <input matInput type="text" placeholder="{{ 'Commune' | translate }}" autocomplete="communeName" formControlName="communeName" />
                                  @if (
                                    familyMemberAddressForm?.get('abroadAddress.communeName')?.invalid &&
                                    familyMemberAddressForm?.get('abroadAddress.communeName')?.touched
                                    ) {
                                    <mat-error
                                      >
                                      {{ 'InvalidField' | translate }}
                                    </mat-error>
                                  }
                                </mat-form-field>
                              </div>
                            </div>
                            <div formGroupName="abroadAddress" class="row">
                              <div class="col-12 col-lg-4">
                                <mat-form-field appearance="outline">
                                  <mat-label>{{ 'City' | translate }}</mat-label>
                                  <input matInput type="text" placeholder="{{ 'City' | translate }}" formControlName="cityName" autocomplete="cityName" required />
                                  @if (
                                    familyMemberAddressForm?.get('abroadAddress.cityName')?.invalid && familyMemberAddressForm?.get('abroadAddress.cityName')?.touched
                                    ) {
                                    <mat-error
                                      >
                                      {{ 'InvalidField' | translate }}
                                    </mat-error>
                                  }
                                </mat-form-field>
                              </div>
                              <div class="col-12 col-lg-4">
                                <mat-form-field appearance="outline">
                                  <mat-label>{{ 'Street' | translate }}</mat-label>
                                  <input matInput type="text" placeholder="{{ 'Street' | translate }}" formControlName="streetName" autocomplete="streetName" required />
                                  @if (
                                    familyMemberAddressForm?.get('abroadAddress.streetName')?.invalid && familyMemberAddressForm?.get('abroadAddress.streetName')?.touched
                                    ) {
                                    <mat-error
                                      >
                                      {{ 'InvalidField' | translate }}
                                    </mat-error>
                                  }
                                </mat-form-field>
                              </div>
                              <div class="col-6 col-lg-2">
                                <mat-form-field appearance="outline">
                                  <mat-label>{{ 'HouseNumber' | translate }}</mat-label>
                                  <input
                                    matInput
                                    type="text"
                                    placeholder="{{ 'HouseNumber' | translate }}"
                                    autocomplete="houseNumber"
                                    formControlName="houseNumber"
                                    required
                                    />
                                    @if (
                                      familyMemberAddressForm?.get('abroadAddress.houseNumber')?.invalid &&
                                      familyMemberAddressForm?.get('abroadAddress.houseNumber')?.touched
                                      ) {
                                      <mat-error
                                        >
                                        {{ 'InvalidField' | translate }}
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                                <div class="col-6 col-lg-2">
                                  <mat-form-field appearance="outline">
                                    <mat-label>{{ 'ApartmentNumber' | translate }}</mat-label>
                                    <input
                                      matInput
                                      type="text"
                                      placeholder="{{ 'ApartmentNumber' | translate }}"
                                      autocomplete="apartmentNumber"
                                      formControlName="apartmentNumber"
                                      />
                                      @if (
                                        familyMemberAddressForm?.get('abroadAddress.apartmentNumber')?.invalid &&
                                        familyMemberAddressForm?.get('abroadAddress.apartmentNumber')?.touched
                                        ) {
                                        <mat-error
                                          >
                                          {{ 'InvalidField' | translate }}
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                  </div>
                                </div>
                                <div formGroupName="abroadAddress" class="row">
                                  <div class="col-12 col-lg-4">
                                    <mat-form-field appearance="outline">
                                      <mat-label>{{ 'Postcode' | translate }}</mat-label>
                                      <input matInput type="text" placeholder="{{ 'Postcode' | translate }}" autocomplete="zip" formControlName="postcode" required />
                                      @if (
                                        familyMemberAddressForm?.get('abroadAddress.postcode')?.invalid && familyMemberAddressForm?.get('abroadAddress.districtName')?.touched
                                        ) {
                                        <mat-error
                                          >
                                          {{ 'InvalidField' | translate }}
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                  </div>
                                  <div class="col-12 col-lg-8">
                                    <mat-form-field appearance="outline">
                                      <mat-label>{{ 'PostOffice' | translate }}</mat-label>
                                      <input matInput type="text" placeholder="{{ 'PostOffice' | translate }}" autocomplete="postOffice" formControlName="postOffice" />
                                      @if (
                                        familyMemberAddressForm?.get('abroadAddress.postOffice').invalid && familyMemberAddressForm?.get('abroadAddress.postOffice').touched
                                        ) {
                                        <mat-error
                                          >
                                          {{ 'InvalidField' | translate }}
                                        </mat-error>
                                      }
                                    </mat-form-field>
                                  </div>
                                </div>
                              </div>
                            }
                          }
                        </div>
                      }
                    </div>
